export default function CopyFooter() {
  return (

    <div className="copy-footer">
      {/* <span className="footnote-text">Contact</span> */}
      <span className="footnote-text">&copy; 2026 Nonhuman Teachers</span>
    </div>

  )
}